import {createSelector} from 'reselect';

export const uniportalSelector = state => state.app;

export const routerSelector = state => state.router;

export const locationSelector = createSelector(routerSelector, router => router.location || {});
export const pathSelector = createSelector(locationSelector, location => location.pathname || "");